/* eslint-disable import/prefer-default-export */

export default {
  INIT_STORE: 'SHARE/INIT_STORE',
  CLEAR_SELECTION: 'SHARE/CLEAR_SELECTION',
  ADD_ESTIMATE: 'SHARE/ADD_ESTIMATE',
  REMOVE_ESTIMATE: 'SHARE/REMOVE_ESTIMATE',
  SHARE_ESTIMATE_SUCCESS: 'SHARE/SHARE_ESTIMATE_SUCCESS',
  SHARE_MODAL: 'SHARE/SHARE_MODAL',
  SHARE_MODAL_DISMISSED: 'SHARE/SHARE_MODAL_DISMISSED',
  UPDATE_SIGNATURE: 'SHARE/UPDATE_SIGNATURE',
};
